import { Tooltip as BaseTooltip } from "@base-ui/react/tooltip";
import type { ReactElement } from "react";

export const TooltipProvider = BaseTooltip.Provider;

export function Tooltip({ content, children }: { content: string; children: ReactElement }) {
  return (
    <BaseTooltip.Root>
      <BaseTooltip.Trigger render={children} />
      <BaseTooltip.Portal>
        <BaseTooltip.Positioner sideOffset={8} className="z-50">
          <BaseTooltip.Popup className="max-w-64 rounded-xl bg-[#1f2544] px-3 py-2 text-sm font-bold text-white shadow-lg transition data-[ending-style]:opacity-0 data-[starting-style]:opacity-0">
            {content}
          </BaseTooltip.Popup>
        </BaseTooltip.Positioner>
      </BaseTooltip.Portal>
    </BaseTooltip.Root>
  );
}
